module.exports = __webpack_public_path__ + "img/JT_icons01_64px_EliteOn.240282d6.svg";